import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {Observable} from 'rxjs/internal/Observable';
import {HistoryStoreItem} from '../../models/history/history-store-item.model';
import {AppQuery} from '../../queries/app.query';
import {NavigationService} from '../../services/navigation/navigation.service';
import {IconsComponent} from '../dummy-components/icons.component';
import {ClickFinderService} from '../../services/click-finder/click-finder.service';
import {TranslateModule} from '@ngx-translate/core';
import {AsyncPipe} from '@angular/common';
import {AppButtonTypeEnum} from '../../enums/button/app-button-type.enum';
import {AuthImagePipe} from '../../pipes/auth-image.pipe';
import {URL_PATH_CONFIGS} from '../../../configs/url-path.config';
import {UrlParamsService} from '../../services/url-params/url-params.service';
import {AppService} from '../../services/app/app.service';
import {IconComponent} from '../icon/icon.component';
import {AppIconSizeEnum} from '../../enums/app-icon-size.enum';
import {ButtonComponent} from '../buttons/button/button.component';
import {ButtonColorEnum} from '../../enums/button/button-color.enum';

@Component({
    selector: 'app-history-dashboard',
    templateUrl: './history-dashboard.component.html',
    styleUrls: ['./history-dashboard.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        AsyncPipe,
        TranslateModule,
        AuthImagePipe,
        IconComponent,
        ButtonComponent,
    ]
})
export class HistoryDashboardComponent extends IconsComponent {
    protected readonly AppButtonTypeEnum = AppButtonTypeEnum;
    protected history$: Observable<Array<HistoryStoreItem>>;
    protected readonly AppIconSizeEnum = AppIconSizeEnum;
    protected readonly ButtonColorEnum = ButtonColorEnum;
    private readonly appQuery = inject(AppQuery);
    private readonly appService = inject(AppService);
    private readonly navigationService = inject(NavigationService);
    private readonly clickFinderService = inject(ClickFinderService);
    private readonly urlParamsService = inject(UrlParamsService);

    public constructor() {
        super();
        this.history$ = this.appQuery.history$;
    }

    protected async hideOverlay(historyItem?: HistoryStoreItem): Promise<void> {
        this.appService.hideHistoryOverlay();

        if (historyItem) {
            await this.navigationService.navigate(historyItem.path, { queryParams: historyItem.queryParams }, false, historyItem);
        }
    }

    protected async handleHistoryItemClick(historyItem: HistoryStoreItem): Promise<void> {
        await this.hideOverlay(historyItem);

        // This is needed to go back to the highest level of the click finder when the history item is clicked.
        if (historyItem.path.join('/') === URL_PATH_CONFIGS.paths.clickFinder) {
            this.clickFinderService.reset();
            const vaultId = this.urlParamsService.getCurrentQueryParams().vaultId;
            if (!vaultId) {
                return;
            }

            const isDocumentTypeRootNode = historyItem.title === 'DOCUMENT_TYPES';
            const rootNode = await this.clickFinderService.getRootNodeByVaultId(vaultId, isDocumentTypeRootNode);
            this.clickFinderService.setActiveRootNode(rootNode);
        }
    }
}
